import { Component, ViewChild } from '@angular/core';
import { AlertController, Content, LoadingController, NavController, NavParams } from 'ionic-angular';
import { SearchService } from '../../providers/search';
import { ErrorHandling } from '../../shared/error.handling';
import { ConfigService } from '../../providers/config';

@Component({
    selector: 'page-file-result-list',
    templateUrl: 'file-result-list.html'
})
export class FileResultListPage {

    fileList: any = [];
    category: string;
    fileInfos: any;
    filesCount: string;
    objId: string;
    config: any = {};

    @ViewChild(Content) content: Content;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public searchService: SearchService,
                public loadingCtrl: LoadingController,
                public alertCtrl: AlertController,
                public errorHandling: ErrorHandling,
                public configService: ConfigService) {

        this.category = navParams.get('orgaStruct');
        this.fileInfos = navParams.get('fileInfos');
        this.filesCount = navParams.get('filesCount');
        this.objId = navParams.get('objId');
    }

    /**
     * Loads config and gets file list
     */
    ionViewDidLoad() {
        this.config = this.configService.getConfig();
        this.getFileList(this.fileInfos);
    }

    // /** Navigates back to search page */
    // getSearchPage() {
    //     this.navCtrl.setRoot(SearchPage, {}, {direction: 'back'});
    // }

    /**
     * Loads file list from server
     * @param obj
     */
    getFileList(obj) {
        Object.keys(obj).forEach((key) => {
            let storedtoken = localStorage.getItem('nodetoken');
            let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

            this.objId = this.objId.replace(':', '-');

            let temp: any = {
                'name': key,
                'lastChange': obj[key].LastChange,
                'size': obj[key].Size,
                'url': storedendpoint.apiendpoint + 'organizations/' + this.category + '/objects/' + this.objId + '/files' + '?X-NODE-TOKEN=' + storedtoken + '&filename=' + key
            };

            this.fileList.push(temp);
        });
    }
}




// WEBPACK FOOTER //
// ./src/pages/file-result-list/file-result-list.ts